import React from "react";

import { useUpdateProductVisibilityMutation } from "@dashboard/products/api";
import { SelectField } from "@shared/form/SelectField/SelectField";
import { MultipleSelectFieldProps } from "@shared/form/SelectField/SelectField.types";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";
import { showSuccessToast } from "@shared/toasts/Toasts";

const visibilityOptions = [
    { value: "ExportableBuilds", label: "Exportable builds" },
    { value: "PublicInheritance", label: "Public inheritance" },
    { value: "PublicFirmware", label: "Public firmware" },
    { value: "PublicDeviceRegistration", label: "Public device registration" },
];

export type VisibilityCellProps = { product: API.Product };

export const VisibilityCell = (props: VisibilityCellProps) => {
    const [selectedValues, setSelectedValues] = React.useState<string[]>(props.product.visibility ?? []);

    const [updateProductVisibility] = useUpdateProductVisibilityMutation();

    const handleVisibilityChange: MultipleSelectFieldProps["onChange"] = async (_event, selectedOption) => {
        const selectedValuesToSet = selectedOption.map((option) => option.value.toString());
        const result = await updateProductVisibility({ productId: props.product.id, visibility: selectedValuesToSet });
        if (!("error" in result)) {
            setSelectedValues(selectedValuesToSet);
            showSuccessToast("Visibility updated successfully");
        }
    };

    return (
        <MinimalTableCell>
            <SelectField
                options={visibilityOptions}
                value={visibilityOptions.filter((option) => selectedValues.includes(option.value))}
                onChange={handleVisibilityChange}
                fullWidth
                multiple
            />
        </MinimalTableCell>
    );
};
